export const getRootPath = () => {
  var curPageUrl = window.document.location.href;
  var rootPath = curPageUrl.split('//')[1].split('/')[1];
  // 频道那块由于秒杀频道的路由冲突，需要临时变更行业频道路由，等秒杀迁移之后，就换回来
  if (rootPath == 'channel-service') return rootPath + '/position';
  return rootPath;
};
